import { Box, Stack, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import IconComponent from "../../../common/components/IconComponent";
import { TabsModel } from "../../Models/TabsModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ display: value !== index ? "none" : "block" }}
    >
      <Box sx={{ pt: 1 }}>{children}</Box>
    </div>
  );
};

const TabsComponent: React.FC<IComponentProps<TabsModel>> = ({ component, context }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const componentLayoutSx = getComponentLayout(component);

  return (
    <Stack direction="column" sx={{ width: "100%", ...componentLayoutSx }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={selectedTab} onChange={handleChange} aria-label="tabs" variant={component.FullWidth ? "fullWidth" : undefined}>
          {component.Items.map((tab, index) => (
            <Tab
              key={index}
              label={tab.Label}
              icon={tab.IconName ? <IconComponent iconName={tab.IconName} /> : undefined}
              iconPosition="start"
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
            />
          ))}
        </Tabs>
      </Box>
      {component.Children.map((child, index) => (
        <TabPanel key={child.Id} value={selectedTab} index={index}>
          <ComponentFactory parent={component} component={child} context={context} />
        </TabPanel>
      ))}
    </Stack>
  );
};

export default TabsComponent;
